<form [formGroup]="form">
  <div class="header">
    <div class="title">
      <fa-icon [icon]="getFaIcon('faChevronLeft')" class="backIcon" (click)="back()" (keypress)="back()" matTooltip="Annuler l'édition"
        appChangeColorTheme attribute="color">
      </fa-icon>

      <h2>{{ offer ? "Édition d'un article" : "Création d'un article"}}</h2>

      <fa-icon [icon]="getFaIcon('faLink')" class="copyLink" [matTooltip]="'Copier le lien de l\'article'"
        *ngIf="mode === 'edit'" (click)="copyString()" (keypress)="copyString()" appChangeColorTheme attribute="color"></fa-icon>

      <button matTooltip="Annuler l'édition" class="back" (click)="back()">Annuler</button>
    </div>
  </div>

  <mat-tab-group [(selectedIndex)]="tabSelectedIndex" (selectedTabChange)="onTabChanged($event);">
    <mat-tab label="Description de l'article">
      <app-admin-offer-edit-description *ngIf="!isLoading" [userConnected]="userConnected" [mode]="mode"
        [offer]="offer ?? null" [form]="form" [clubs]="clubs" [universes]="universes" (fileUpdate)="updateFile($event)"
        [parameters]="parameters" [practicesClub]="practicesClub" (editFinished)="editFinished.next($event)"
        (offerPreviewUpdate)="offerPreviewUpdate.next($event)" [disciplines]="disciplines" [articleDisciplines]="articleDisciplines"
        (getActorKey)="getActorKey($event)" (getDisciplineKey)="getDisciplineKey($event)" (getFormDefinition)="getFormDefinition($event)"
        [places]="places" (getPlaces)="places=$event" [forms]="forms" [associatedForm]="associatedForm"
        (imageUpdate)="imageUpdate.next($event)"></app-admin-offer-edit-description>

      <mat-spinner *ngIf="isLoading" style="margin: 0 auto;" color="primary" diameter="50"></mat-spinner>
    </mat-tab>
  </mat-tab-group>


  <div class="btn_action">
    <button class="back" type="button" matTooltip="Annuler l'édition" (click)="back()">Annuler</button>

    <button *ngIf="tabSelectedIndex === 1" class="back" type="button" matTooltip="Revenir à la description"
      (click)="tabSelectedIndex = 0">Précédent</button>

    <button (click)="onSubmit()" *ngIf="tabSelectedIndex === 0" class="confirm" type="button"
      [disabled]="isLoading || form.invalid" appChangeColorTheme attribute="bgc">
      {{ !form.get('isInternalOffer').value ? "Confirmer" : "Suivant" }}
    </button>

    <button (click)="onSubmit()" *ngIf="tabSelectedIndex === 1" type="button" class="confirm"
      [disabled]="isLoading || form.invalid || pricingForm.invalid || (!pricingForm.get('isPayableAtClub').value && !pricingForm.get('isPayableOnline').value)"
      [style.opacity]="form.invalid || pricingForm.invalid || (!pricingForm.get('isPayableAtClub').value && !pricingForm.get('isPayableOnline').value) ? .5 : 1"
      appChangeColorTheme attribute="bgc">Confirmer</button>
  </div>
</form>
